import { clearToken, getToken, notifyAuthChanged } from '@/lib/auth-storage';
import { clearSaleSmartlyUser } from '@/lib/salesmartly';

/** 与 vite 代理一致：开发环境走 `/api` 代理到后端 */
export function apiBase(): string {
  const base = import.meta.env.VITE_API_BASE;
  return typeof base === 'string' ? base : '';
}

export type AjaxResult<T = unknown> = {
  code: number;
  msg: string;
  data?: T;
};

function normalizeCode(code: number): number {
  // Backend may return 200 (Ruoyi default) or 0 (custom success code).
  return code === 200 ? 0 : code;
}

export async function apiFetch<T>(
  path: string,
  init: globalThis.RequestInit & { auth?: boolean } = {},
): Promise<AjaxResult<T>> {
  const { auth = false, headers: hdrs, ...rest } = init;
  const headers = new Headers(hdrs);
  if (!headers.has('Content-Type') && rest.body != null) {
    headers.set('Content-Type', 'application/json');
  }
  if (auth) {
    const t = getToken();
    if (t) {
      headers.set('Authorization', `Bearer ${t}`);
    }
  }
  const url = `${apiBase()}${path.startsWith('/') ? path : `/${path}`}`;
  const res = await fetch(url, { ...rest, headers });
  const json = (await res.json()) as AjaxResult<T>;
  if (res.status === 401) {
    clearToken();
    clearSaleSmartlyUser();
    notifyAuthChanged();
  }
  return { ...json, code: normalizeCode(json.code) };
}
